import { primaryRegularFont, primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const list = css`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const item = css`
  display: flex;
  align-items: center;
  gap: ${spacing.sm}px;
  margin-bottom: ${spacing.xs}px;
`;

export const message = css`
  width: calc(100% - ${spacing.xxl}px);
  margin: 0;
  ${primaryRegularFont};
  ${responsiveText.BODY.SM};

  b {
    ${primarySemiBoldFont};
  }

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const noOptionMessage = css`
  ${responsiveText.BODY.MD};
`;
